// Navbar.js
import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import { FaUserCircle } from 'react-icons/fa';

const Navbar = () => {
  const [user, setUser] = useState(null);

  useEffect(() => {
    const storedUser = JSON.parse(localStorage.getItem('loggedInUser'));
    if (storedUser) {
      setUser(storedUser);
    }
  }, []);

  return (
    <nav className="navbar navbar-expand-lg navbar-dark bg-success">
      <div className="container">
        <Link className="navbar-brand" to="/">PharmaCart</Link>
        <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNav">
          <span className="navbar-toggler-icon"></span>
        </button>

        <div className="collapse navbar-collapse" id="navbarNav">
          <ul className="navbar-nav ms-auto">
            <li className="nav-item">
              <Link className="nav-link" to="/">Home</Link>
            </li>
            {/* Products Dropdown */}
            <li className="nav-item dropdown">
              <a
                className="nav-link dropdown-toggle"
                href="#"
                id="productDropdown"
                role="button"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
                Products
              </a>

              <ul className="dropdown-menu" aria-labelledby="productDropdown">
                <li>
                  <Link className="dropdown-item fw-bold">All Products</Link>
                </li>
                <li><hr className="dropdown-divider" /></li>
                <li><Link className="dropdown-item" to="/medicines">Medicines</Link></li>
                <li><Link className="dropdown-item" to="/wellness">Wellness</Link></li>
                <li><Link className="dropdown-item" to="/personal">Personal Care</Link></li>
                <li><Link className="dropdown-item" to="/devices">Devices</Link></li>
              </ul>
            </li>
            <li className="nav-item">
              <Link className="nav-link" to="/book-pharmacist">Book Appointment</Link>
            </li>
            <li className="nav-item">
              <Link className="nav-link" to="/cart">Cart</Link>
            </li>
            <li className="nav-item">
              {
                user ? (
                  <Link className="nav-link d-flex align-items-center" to="/profile">
                    <FaUserCircle className="me-2" />
                    {user.name}
                  </Link>
                ) : (
                  <Link className="nav-link d-flex align-items-center" to="/login">
                    <FaUserCircle className="me-2" />
                    Login
                  </Link>
                )
              }
            </li>
          </ul>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
